(function () {
  function replaceQuickViewButtons(root) {
    var selector = 'button.product-item__action-button[data-secondary-action="open-quick-view"]';
    var buttons = (root || document).querySelectorAll(selector);

    buttons.forEach(function (button) {
      if (button.__viewProductApplied) return;
      var productUrl = button.getAttribute('data-product-url');
      if (!productUrl) return;

      var link = document.createElement('a');
      link.href = productUrl;
      link.textContent = 'View Product';
      link.className = 'button button--small button--ternary product-item__action-button';
      button.parentNode.replaceChild(link, button);
      link.__viewProductApplied = true;
    });
  }

  // Retry for delayed loads
  function retryReplace(tries) {
    replaceQuickViewButtons();
    if (tries < 30) setTimeout(function(){ retryReplace(tries + 1); }, 300);
  }

  // Keep watching for theme re-renders (Warehouse reloads sections dynamically)
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      for (var i = 0; i < m.addedNodes.length; i++) {
        var node = m.addedNodes[i];
        if (node.nodeType === 1) replaceQuickViewButtons(node);
      }
    });
  });

  document.addEventListener('DOMContentLoaded', function () {
    retryReplace(0);
    observer.observe(document.body, { childList: true, subtree: true });
  });

  // Safety: intercept any residual Quick view click
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button[data-secondary-action="open-quick-view"]');
    if (!btn) return;
    var url = btn.getAttribute('data-product-url');
    if (!url) return;
    e.preventDefault();
    e.stopPropagation();
    window.location.href = url;
  }, true);
})();
